import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-loading-component',
  standalone: true,
  templateUrl: './loading-component.html',
  styleUrl: './loading-component.css',
})
export class LoadingComponent implements OnChanges {
  @Input() title = 'Loading';
  @Input() message = 'Please wait...';
  @Input() flavorTextOptions?: string[];

  private readonly defaultFlavorTextOptions = [
    'Sharpening quills and unsealing ancient records.',
    'Consulting the tavern ledgers for the next clue.',
    'Gathering whispers from the far corners of the realm.',
    'Bribing the archive goblins for a faster answer.',
    'Dusting off a well-worn tome of adventuring lore.',
    'Rolling fate across the table one more time.',
    'Summoning a patient scribe from the guild hall.',
    'Marking fresh notes in the codex margins.',
  ];

  flavorText = '';

  ngOnChanges(_changes: SimpleChanges): void {
    this.flavorText = this.pickFlavorText();
  }

  private pickFlavorText(): string {
    const options = this.flavorTextOptions?.length
      ? this.flavorTextOptions
      : this.defaultFlavorTextOptions;

    return options[Math.floor(Math.random() * options.length)];
  }
}
